import React from 'react';
import { render, fireEvent } from '@testing-library/react';
import ThemeUploadPicker from './theme_upload_picker';

// Mock sub_nav
jest.mock('../sub_nav/sub_nav', () => () => <div data-testid="sub-nav" />);

const mockParsedTheme = {
    name: 'Test Theme',
    source_filename: 'test.protheme',
    slides: [
        { name: 'Point', suggested_type: 'point', font_name: 'Avenir', font_size: 90, text_color: { r: 1, g: 1, b: 1, a: 1 } },
        { name: 'Scripture', suggested_type: 'scripture', font_name: 'Avenir', font_size: 80, text_color: { r: 1, g: 1, b: 1, a: 1 } },
    ],
};

describe('ThemeUploadPicker', () => {
    it('renders theme name input', () => {
        const { getByDisplayValue } = render(
            <ThemeUploadPicker parsedTheme={mockParsedTheme} onSave={jest.fn()} onCancel={jest.fn()} />
        );
        expect(getByDisplayValue('Test Theme')).toBeTruthy();
    });

    it('renders slide preview cards', () => {
        const { getAllByText } = render(
            <ThemeUploadPicker parsedTheme={mockParsedTheme} onSave={jest.fn()} onCancel={jest.fn()} />
        );
        expect(getAllByText('Sample Text').length).toBe(2);
    });

    it('renders mapping dropdowns', () => {
        const { getAllByRole } = render(
            <ThemeUploadPicker parsedTheme={mockParsedTheme} onSave={jest.fn()} onCancel={jest.fn()} />
        );
        const selects = getAllByRole('combobox');
        expect(selects.length).toBe(2);
    });

    it('calls onSave with mapped data when Save clicked', () => {
        const onSave = jest.fn();
        const { getByText } = render(
            <ThemeUploadPicker parsedTheme={mockParsedTheme} onSave={onSave} onCancel={jest.fn()} />
        );
        fireEvent.click(getByText('Save Theme'));
        expect(onSave).toHaveBeenCalledTimes(1);
        expect(onSave.mock.calls[0][0].name).toBe('Test Theme');
        expect(onSave.mock.calls[0][0].slides.length).toBe(2);
    });

    it('calls onCancel when Cancel clicked', () => {
        const onCancel = jest.fn();
        const { getByText } = render(
            <ThemeUploadPicker parsedTheme={mockParsedTheme} onSave={jest.fn()} onCancel={onCancel} />
        );
        fireEvent.click(getByText('Cancel'));
        expect(onCancel).toHaveBeenCalledTimes(1);
    });

    it('includes activate checkbox checked by default', () => {
        const { getByLabelText } = render(
            <ThemeUploadPicker parsedTheme={mockParsedTheme} onSave={jest.fn()} onCancel={jest.fn()} />
        );
        expect(getByLabelText('Set as active theme').checked).toBe(true);
    });
});
